/**
 * CX Bypass Cookie Utility
 *
 * Used to manage the bypass cookie that allows internal users (@shi.com, @stratascale.com)
 * to intentionally access CX instead of being auto-redirected to CS.
 *
 * Cookie is set when:
 * - User navigates from CS to CX (impersonation, preview, etc.)
 *
 * Cookie is checked when:
 * - Internal user logs into CX - if present, skip redirect to CS
 */

const COOKIE_NAME = "shi_cx_access";
const COOKIE_EXPIRY_HOURS = 24;

/**
 * Sets the CX bypass cookie to prevent auto-redirect to CS.
 * Call this before navigating from CS to CX.
 */
export function setCxBypassCookie(): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + COOKIE_EXPIRY_HOURS * 60 * 60 * 1000);

  const isSecure = window.location.protocol === "https:";

  // Don't set domain - browser defaults to exact hostname
  // This works for both one.shi.com and local.one.shi.com
  document.cookie =
    `${COOKIE_NAME}=1; ` +
    `expires=${expires.toUTCString()}; ` +
    `path=/; ` +
    `SameSite=Lax` +
    (isSecure ? "; Secure" : "");
}

/**
 * Checks if the CX bypass cookie is present.
 * @returns true if user should stay on CX, false if eligible for redirect to CS
 */
export function hasCxBypassCookie(): boolean {
  return document.cookie.split(";").some((cookie) => {
    return cookie.trim().startsWith(`${COOKIE_NAME}=`);
  });
}

/**
 * Clears the CX bypass cookie.
 * Can be used if we need to force redirect behavior.
 */
export function clearCxBypassCookie(): void {
  document.cookie = `${COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
